import { validateCookieString } from './modules/validation.js';
/**
 * Method 'setCookie' sets cookie with the given value.
 * @param {String} name - Name of the cookie
 * @param {String} value - Value to be saved into the cookie
 * @param {Object} [configuration = {}] - additional configuration of the cookie
 * Example configuration = {path: '/', domain: 'domain.com', secure: true, ..}
 * Default configuration = {path: '/'}
 */
export const setCookie = (name, value, configuration = {}) => {
    const options = {
        path: '/',
        ...configuration,
    };
    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }
    let updatedCookie = validateCookieString(`${name}=${value}`);
    for (const optionKey in options) {
        const optionValue = options[optionKey];
        if (!optionValue) {
            continue;
        }
        updatedCookie += '; ' + optionKey + (optionValue === true ? '' : '=' + optionValue);
    }
    document.cookie = updatedCookie;
};
/**
 * Method 'getCookie' gets cookie with provided name.
 * @param {String} name - Name of the cookie
 * @return {null | String } - description of each case:
 * null there is not cookie
 * string with value of cookie
 * string[] array of value of cookies (several cookies of the same name were found)
 */
export const getCookie = (name) => {
    const { [1]: match } = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')) ??
        [];
    return match ? decodeURIComponent(match) : null;
};
/**
 * Method 'removeCookie' deletes cookie with provided name.
 * @param {String} name - Name of the cookie
 * @param {Object} [configuration = {}] - additional configuration of the cookie
 * Example configuration = {path: '/', domain: 'domain.com', secure: true, ..}
 */
export const removeCookie = (name, configuration = {}) => {
    configuration['max-age'] = -1;
    setCookie(name, '', configuration);
};
